export default __webpack_public_path__ + "static/brush-stroke-green-cyan-9b064b10ce735782538fdddc4fc5ca25.svg";